import {
  LISTA_TROCA_FOTO,
  LISTA_TROCA_FOTO_SUCESSO,
  LISTA_TROCA_FOTO_ERRO,
  APROVA_TROCA_FOTO,
  APROVA_TROCA_FOTO_SUCESSO,
  REPROVA_TROCA_FOTO,
  REPROVA_TROCA_FOTO_SUCESSO,
  TROCA_FOTO_ERRO,
} from 'constants/ActionTypes';

export const listaTrocaFoto = (pagina = 1, tamanhoPagina = 20, status = 'PENDENTE') => ({
  type: LISTA_TROCA_FOTO,
  payload: { pagina, tamanhoPagina, status },
});

export const listaTrocaFotoSucesso = (data) => ({
  type: LISTA_TROCA_FOTO_SUCESSO,
  payload: data,
});

export const listaTrocaFotoErro = (mensagem) => ({
  type: LISTA_TROCA_FOTO_ERRO,
  payload: mensagem,
});

export const aprovaTrocaFoto = (id) => ({
  type: APROVA_TROCA_FOTO,
  payload: { id },
});

export const aprovaTrocaFotoSucesso = () => ({
  type: APROVA_TROCA_FOTO_SUCESSO,
});

export const reprovaTrocaFoto = (id, motivo) => ({
  type: REPROVA_TROCA_FOTO,
  payload: { id, motivo },
});

export const reprovaTrocaFotoSucesso = () => ({
  type: REPROVA_TROCA_FOTO_SUCESSO,
});

export const trocaFotoErro = (mensagem) => ({
  type: TROCA_FOTO_ERRO,
  payload: mensagem,
});
